<template>
	<div class="page-wrapper">
		<div class="page-content">
			<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
				<div class="breadcrumb-title pe-3">Exclusive Brand</div>
				<div class="ps-3">
					<nav aria-label="breadcrumb">
						<ol class="breadcrumb mb-0 p-0">
							<li class="breadcrumb-item">
								<router-link to="/dashboard">
									<i class="bx bx-home-alt"></i>
								</router-link>
							</li>
							<li class="breadcrumb-item active" aria-current="page">Exclusive Brand Page CMS</li>
						</ol>
					</nav>
				</div>
			</div>
			<form @submit.prevent="updateCms()">
				<div class="card">
					<div class="card-body">
						<h5 class="card-title">Exclusive Brand Page CMS</h5>
						<hr />
						<div class="form-body mt-4">
							<div class="row">
								<div class="col-lg-8 mb-3">
									<div class="border border-3 p-4 rounded">
										<div class="row">
											<div class="col-12 mb-3">
												<label class="form-label">Page Title:</label>
												<input type="text" v-model="cmsData.pageTitle" class="form-control" id="inputPageHeaderTitle" placeholder="Enter page title" />
											</div>
											<div class="col-12 mb-3">
												<label class="form-label">Brand Section Title:</label>
												<input type="text" v-model="cmsData.brandSectionTitle" class="form-control" id="inputPageHeaderTitle" placeholder="Enter brand section title" />
											</div>
										</div>
									</div>
								</div>
								<div class="d-grid col-lg-8">
									<button type="submit" class="btn btn-primary">Save</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script src="../js/exclusive-brand-page-cms.js"></script>